<div class="mat-app-background">

  <!-- TOP TOOLBAR -->
  <mat-toolbar color="primary" class="toolbar disabled-border-color">
    <mat-toolbar-row>
      <!-- MOBILE MENU BUTTON -->
      <button
        mat-icon-button
        (click)="cmsnav.toggle()"
        class="menu-icon-button d-md-none"
      >
        <mat-icon class="menu-icon">menu</mat-icon>
      </button>


      <div class="link d-none d-md-flex hover-accent-background" *ngFor="let route of routes" [routerLink]="route.routerLink" routerLinkActive="light-primary-background deep-dark-color">
        <div class="item">
          <a class="inner-item-display light-color hover-light-color">
            {{ route.name }}
            <mat-icon *ngIf="(route.children && route.children.length)" class="menu-arrow">arrow_drop_down</mat-icon>
          </a>
        </div>

        <!-- CHILD DROPDOWN -->
        <div class="subnav" *ngIf="route.children && route.children.length" (click)="$event.stopPropagation()">
          <div class="subnav-item hover-lightest-primary-background" *ngFor="let child of route.children">
            <a [routerLink]="child.routerLink" [queryParams]="child.queryParams" class="dark-color hover-primary-color">
              {{ child.name }}
            </a>
          </div>
        </div>
      </div>

      <span class="spacer"></span>

      <div class="brand">
        <div class="brand-name hover-accent" [routerLink]="['/cms', 'account']">{{ account.name }}</div>
        <div class="version-name hover-accent" [routerLink]="['/cms', 'release-notes']">(Version {{version}})</div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container">
    <!-- MOBILE SIDE NAV -->
    <mat-sidenav #cmsnav>
      <div *ngFor="let route of routes" class="hover-lightest-accent-background" routerLinkActive="accent-background app-active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="route.routerLink" (click)="cmsnav.close()">
        <div class="sidenav-route">
          {{ route.name }}
        </div>

        <div *ngFor="let child of route.children" (click)="$event.stopPropagation()" class="child-link lightest-accent-background">
          <a *ngIf="child.routerLink" [routerLink]="child.routerLink">
              {{ child.name }}
          </a>
        </div>

      </div>
    </mat-sidenav>

    <!-- CONTENT -->
    <mat-sidenav-content style="overflow-x: hidden;">
      <div class="outlet-container cms">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>


</div>
